/**
 * Convertes entry filter params into searchUrl
 *
 * @param entry, type, from, limit
 * @returns {url}
 */
export default function getHighlightedSearchUrl(from, limit, type, ageId, site) {
  if (!type) return null
  const searchApiUrl = process.env.NEXT_PUBLIC_ELASTICSEARCH_API
  const searchType = type
  const searchParams = new URLSearchParams()

  if (ageId) {
    searchParams.append('ageCategories[]', ageId)
  }

  // to be made dependant on logged in team age category
  searchParams.append('from', from)
  searchParams.append('limit', limit)
  searchParams.append('site', site)

  const searchResultsQuery = searchParams.toString().length ? `?${searchParams.toString()}` : ''
  const searchUrl = `${searchApiUrl}/${searchType}/search${searchResultsQuery}`
  return searchUrl
}
